import { defineRecipe } from '@chakra-ui/react';

export const inputRecipe = defineRecipe({
  base: {
    borderRadius: 'l1',
  },
  variants: {
    size: {
      md: {
        '--input-height': 'sizes.8',
        px: 2,
      },
    },
    variant: {
      outline: {
        borderColor: '{colors.neutral.100}',
      },
    },
  },
});
